import type {ReactElement} from 'react'
import {Routes} from '@freckle/school/ts/common/routers/routes'
import Filter from '@freckle/school/ts/manage-teachers/components/filter'
import type {CourseTabFilteringT} from './'

type Props = {
  currentSchoolIds: Array<number> | undefined | null
  courseTabFilter: CourseTabFilteringT | undefined | null
}

export default function CourseTabFilter(props: Props): ReactElement | null {
  const {courseTabFilter, currentSchoolIds} = props

  if (courseTabFilter === null || courseTabFilter === undefined) {
    return null
  }

  const url = Routes.dashboard({
    schoolIds: currentSchoolIds,
    activeTab: 'course-tab',
  })

  const {sisIdExists, student} = courseTabFilter

  if (sisIdExists !== undefined) {
    const name = sisIdExists ? `Admin-created courses` : `Non-Admin-created courses`
    return <Filter name={name} url={url} />
  }

  if (student !== undefined) {
    const name = `Courses with ${student.name}`
    return <Filter name={name} url={url} />
  }

  return null
}
